import React, { useEffect } from "react";

interface Props {
  redirectTo?: () => void;
  state: string | boolean;
  answer: string | boolean;
  redirectIfTrue?: () => void;
  redirectIfFalse?: () => void;
}

export const PrivateRoute: React.FC<Props> = React.memo(
  ({ children, state, answer, redirectIfTrue, redirectIfFalse }) => {

    useEffect(() => {
      if (state === answer) {
        redirectIfTrue && redirectIfTrue();
      } else {
        redirectIfFalse && redirectIfFalse();
      }
    }, []);

    return <>{children}</>;
  }
);
